
import { useState, useEffect } from 'react';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { useParams } from "react-router-dom";
import { FormattedMessage } from 'react-intl';
import { RootState } from '@share/utils';
import { verifyUser } from '@share/store/slices';

import './style.scss';

interface IMapDispatchToProps {
  verify: (token: string) => void;
}

interface IProps extends IMapDispatchToProps, RouteComponentProps { }

function VerifyUserComponent(props: IProps) {
  const [load, setLoad] = useState(false);
  const params: any = useParams();

  useEffect(() => {
    setLoad(!load);
  }, [])

  useEffect(() => {
    if (load) {
      handleVerify(params.token);
    }
  }, [load])

  const handleVerify = (token: string) => {
    props.verify(token);
  }

  return (
    <div className="password-page">
      <div className="container-fluid">
        <div className="row content">
          <div className="col-6">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <h1><FormattedMessage id="verify.your.user" /></h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: ThunkDispatch<RootState, undefined, Action>): IMapDispatchToProps => ({
  verify: (token: string) => {
    dispatch(verifyUser(token));
  }
});

const VerifyUserComponentRouter = withRouter(VerifyUserComponent);

export const VerifyUser = connect(null, mapDispatchToProps)(VerifyUserComponentRouter);
